export enum DiagnosticType {
    Domain = "DOMAIN",
    Address = "ADDRESS",
    SSH = "SSH",
}